import "./DetailField.scss";

export default {
  props: {
    title: String,
    largeBorder: Boolean,
  },
};
